import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { TREATMENTS } from "@/data/treatments";

const FEATURED_SLUGS = [
  "botox",
  "dermal-fillers",
  "laser-hair-removal",
  "chemical-peels",
  "microneedling",
  "coolsculpting",
  "rf-microneedling",
  "hydrafacial",
  "iv-therapy",
];

const featured = FEATURED_SLUGS.map((slug) =>
  TREATMENTS.find((t) => t.slug === slug)!
).filter(Boolean);

function TreatmentCard({ treatment }: { treatment: (typeof TREATMENTS)[number] }) {
  const description = treatment.description.split("\n")[0];

  return (
    <Link
      to={`/treatments/${treatment.slug}`}
      className="group card-premium p-6 hover:-translate-y-1.5 hover:border-primary/30 transition-all duration-300"
    >
      <div className="w-12 h-12 rounded-2xl bg-primary/10 border border-primary/20 grid place-items-center text-primary mb-4 group-hover:scale-105 transition-transform">
        <Sparkles className="w-5 h-5" />
      </div>
      <h3 className="font-semibold text-lg text-foreground group-hover:text-primary transition-colors mb-2">
        {treatment.name}
      </h3>
      <p className="text-sm text-muted-foreground leading-relaxed line-clamp-2">
        {description}
      </p>
      <span className="inline-flex items-center gap-1 text-sm font-semibold text-teal-300 mt-4 transition-colors">
        Find providers <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
      </span>
    </Link>
  );
}

export default function TreatmentsSection() {
  return (
    <section className="py-16 lg:py-24">
      <div className="container mx-auto px-4 lg:px-8">
        <SectionHeading
          eyebrow="Treatment Discovery"
          title={
            <>
              Popular <span className="text-gradient-aqua">Treatments</span>
            </>
          }
          description="Explore the most sought-after MedSpa treatments and find providers near you"
          action={
            <Link
              to="/treatments"
              className="hidden sm:inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-white/10 bg-white/5 text-sm font-semibold text-foreground hover:border-primary/30 transition-colors"
            >
              View All
              <ArrowRight className="w-4 h-4" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-4">
          {featured.map((t) => (
            <TreatmentCard key={t.slug} treatment={t} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/treatments"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
          >
            View All Treatments
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
